import axios, { CancelTokenSource } from 'axios';

import { APIError, UnsupportedStructureError } from '~services/Errors';

import { CampaignGroupResponse, CampaignGroupResponseDecoder } from './domain';

export const getCampaignGroupsByNextUrl = async (
  nextUrl: string,
  cancelToken?: CancelTokenSource,
): Promise<CampaignGroupResponse | undefined> => {
  const path = nextUrl;
  let resp;

  try {
    resp = await axios.request({
      url: path,
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      cancelToken: cancelToken ? cancelToken.token : undefined,
    });
  } catch (e) {
    if (axios.isCancel(e)) {
      return undefined;
    }

    if (axios.isAxiosError(e)) {
      // Response should always be defined if axios error
      throw new APIError(e.response!.status, (e.response!.data as { error: string }).error || e.message);
    }

    throw new APIError(-1, e as string);
  }

  const decoded = CampaignGroupResponseDecoder.run(resp.data);

  if (decoded.ok === false) {
    const err = new UnsupportedStructureError(decoded.error.message);

    console.error(decoded.error);
    console.error(err);
    throw err;
  }

  return decoded.result;
};

export const getCampaignGroups = async ({
  campaignId,
  search,
  cancelToken,
}: {
  campaignId: number;
  search?: string;
  cancelToken?: CancelTokenSource;
}): Promise<CampaignGroupResponse | undefined> => {
  const path = `/api/internal/campaign/${campaignId}/groups`;
  let resp;
  try {
    resp = await axios.request({
      url: path,
      method: 'GET',
      params: {
        search: search?.toLowerCase() || undefined,
      },
      paramsSerializer: {
        indexes: null,
      },
      headers: {
        Accept: 'application/json',
      },
      cancelToken: cancelToken?.token,
    });
  } catch (e) {
    if (axios.isCancel(e)) {
      return undefined;
    }

    if (axios.isAxiosError(e)) {
      // Response should always be defined if axios error
      throw new APIError(e.response!.status, (e.response!.data as { error: string }).error || e.message);
    }

    throw new APIError(-1, e as string);
  }

  const decoded = CampaignGroupResponseDecoder.run(resp.data);

  if (decoded.ok === false) {
    const err = new UnsupportedStructureError(decoded.error.message);

    console.error(decoded.error);
    console.error(err);
    throw err;
  }

  return decoded.result;
};
